export let StorageKey = /*#__PURE__*/function (StorageKey) {
  StorageKey["darkTheme"] = "dark-theme";
  return StorageKey;
}({});
export let HotKey = /*#__PURE__*/function (HotKey) {
  HotKey["toggleTheme"] = "Alt+Shift+KeyT";
  HotKey["toggleDebugMode"] = "Alt+Shift+KeyL";
  HotKey["toggleLanguage"] = "Alt+Shift+KeyZ";
  HotKey["toggleLanguageCIMode"] = "Alt+Shift+KeyK";
  return HotKey;
}({});